module.exports = __webpack_public_path__ + "static/media/1bed.b62a257a.jpg";